var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletDock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.833 10.5H8.1663V8.16663H19.833M19.833 15.1666H8.1663V12.8333H19.833M16.333 19.8333H8.1663V17.5H16.333M13.9996 3.49996C14.3091 3.49996 14.6058 3.62288 14.8246 3.84167C15.0434 4.06046 15.1663 4.35721 15.1663 4.66663C15.1663 4.97605 15.0434 5.27279 14.8246 5.49158C14.6058 5.71038 14.3091 5.83329 13.9996 5.83329C13.6902 5.83329 13.3935 5.71038 13.1747 5.49158C12.9559 5.27279 12.833 4.97605 12.833 4.66663C12.833 4.35721 12.9559 4.06046 13.1747 3.84167C13.3935 3.62288 13.6902 3.49996 13.9996 3.49996ZM22.1663 3.49996H17.2896C16.7996 2.14663 15.5163 1.16663 13.9996 1.16663C12.483 1.16663 11.1996 2.14663 10.7096 3.49996H5.83297C5.21413 3.49996 4.62064 3.74579 4.18305 4.18338C3.74547 4.62096 3.49963 5.21445 3.49963 5.83329V22.1666C3.49963 22.7855 3.74547 23.379 4.18305 23.8165C4.62064 24.2541 5.21413 24.5 5.83297 24.5H22.1663C22.7851 24.5 23.3786 24.2541 23.8162 23.8165C24.2538 23.379 24.4996 22.7855 24.4996 22.1666V5.83329C24.4996 5.21445 24.2538 4.62096 23.8162 4.18338C23.3786 3.74579 22.7851 3.49996 22.1663 3.49996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletDock);
export default __webpack_public_path__ + "static/media/tablet_dock.62ee383131772be97483d581f30c6a7e.svg";
export { ForwardRef as ReactComponent };